import enjson from './en.json';
import format from 'string-format';

const formatTranslation = function (key, context) {
  return format(enjson[key] || key, context || {});
};

export default formatTranslation;
